
export const makeAlertReducers = (prefix) => {
  const addAlertType = `${prefix}ADD_ALERT`;
  const removeAlertType = `${prefix}REMOVE_ALERT`;
  const clearAlertsType = `${prefix}CLEAR_ALERTS`;

  return {
    alerts: (state = [], action) => {
      if (typeof action.type === "undefined" || !action.type.startsWith(prefix)) {
        return state;
      }

      switch (action.type) {
        case addAlertType:
          return [...state, action.payload];
        case removeAlertType:
          return state.filter((item) => item !== action.payload);
        case clearAlertsType:
          return state.filter((item) => {
            if (item.group === action.payload) {
              if (item.timeout) {
                clearTimeout(item.timeout);
              }
              return false;
            }

            return true;
          });
        default:
          return state;
      }
    }
  };
};

export const makeAlertSelectors = (uiState) => {
  return {
    getAlerts: (state, group = '') => {
      if (!state[uiState] || !state[uiState].alerts) {
        return [];
      }

      return state[uiState].alerts.filter((alert) => alert.group === group);
    }
  };
};
